<div
  class="flex items-center justify-between bg-gradient-to-r from-purple-50 to-white rounded-2xl p-4 mb-2 border border-purple-100 shadow-sm">
  <div class="flex items-center gap-3 text-gray-900 font-semibold">
    <span class="inline-flex items-center justify-center w-8 h-8 rounded-full bg-purple-100 text-purple-700">👑</span>
    <span>Get Premium to keep chatting</span>
  </div>
  <button class="px-4 py-2 bg-black text-white rounded-full hover:bg-gray-800"
          (click)="$event.stopPropagation(); onTryPremiumClick.emit();">TRY PREMIUM
  </button>
</div>
